module.exports = __webpack_public_path__ + "static/media/sad.c3fa0497.svg";